/**
 * Action for ticket selection of wizard view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.WizardStepTicketSelectionAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {WizardAction} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var WizardStepTicketSelectionAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        this.plugin = plugin;

        // Parent plugin container
        this.pluginContainer = pluginContainer;

        // Main container of the action
        this.container = container;

        this.debitorSelect = this.container.querySelector('.debitor-select');
        this.variantsContainer = this.container.querySelector('.variants-data-container');
        this.submitContainer = this.container.querySelector('.submit-row');

        this.ticketButtons = this.container.querySelectorAll('.ticket-btn');

        this.reservationDataTemplate = this.container.querySelector('.reservation-data').cloneNode(true);
        this.reservationDataTemplate.classList.remove('reservation-data');


        //this.initialize();

    };

    WizardStepTicketSelectionAction.prototype.isOpen = function () {
        return this.container.classList.contains('card-active');
    };

    WizardStepTicketSelectionAction.prototype.prefill = function (callback) {
        const self = this;

        self.updateHasDataHeader();
        if (self.hasData() && !self.isOpen()) {
            self.showHasDataHeader();
        }

        var selectedDebitor = self.plugin.getCurrentValue('debitor');

        if (selectedDebitor && this.debitorSelect) {
            self.setActiveDebitor(this.debitorSelect.querySelector('.dropdown-item[data-id="' + selectedDebitor + '"]'));
        }

        var selectedTicket = self.plugin.getCurrentValue('ticket');

        if (selectedTicket) {
            var ticketButton = self.container.querySelector('.ticket-btn[data-id="' + selectedTicket + '"]');
            if (ticketButton) {
                ticketButton.click();
                self.preSubmit(callback);
            } else {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }

        } else {
            GeneralUtility.hideLoadingAnimationOfAllDateSelectionCards();
            if (callback && typeof callback === 'function') {
                callback();
            }
        }
    };

    WizardStepTicketSelectionAction.prototype.initialize = function (callback) {
        const self = this;

        GeneralUtility.showLoadingAnimationOfCard(self.container);

        self.hideHasDataHeader();


        if (self.debitorSelect) {
            new Dropdown(self.debitorSelect);
            self.debitorSelect.querySelectorAll('.dropdown-item').forEach(function (item) {
                item.addEventListener('click', function (event) {
                    self.setActiveDebitor(event.target);
                    return false;
                });
            });
            GeneralUtility.initializeDropdownSearch();
        }


        self.ticketButtons.forEach(function (item) {

            item.addEventListener('click', function (event) {
                self.ticketButtons.forEach(function (item2) {
                    item2.classList.remove('active');
                });
                item.classList.add('active');
                var oldValue = self.plugin.getCurrentValue('ticket');

                self.plugin.setCurrentValue('ticket', item.dataset.id);
                var newValue = self.plugin.getCurrentValue('ticket');

                var oldPersonsValue = self.plugin.getCurrentValue('persons');
                self.loadVariants(item);
                var newPersonsValue = self.plugin.getCurrentValue('persons');
                document.getElementById('max-group-size').innerHTML = item.dataset.max;
                self.variantsContainer.classList.remove('d-none');
                self.submitContainer.classList.remove('d-none');

                self.scrollToPersonFields();

                if (oldValue !== newValue || oldPersonsValue !== newPersonsValue || self.plugin.isInitialLoading) {
                    self.updateDateSelectionSteps();
                }
                self.validateStep();
                return false;
            });
        });

        self.prefill(function () {
            self.validateStep();

            GeneralUtility.hideLoadingAnimationOfCard(self.container);
            if (callback && typeof callback === 'function') {
                callback();
            }
        });

    };


    WizardStepTicketSelectionAction.prototype.scrollToPersonFields = function () {
        const self = this;

        anime({
            targets: document.getElementById('modal-reservation'),
            scrollTop: self.variantsContainer.offsetTop - 100,
            duration: 500,
            easing: 'easeInOutQuad'
        });
    };

    WizardStepTicketSelectionAction.prototype.updateDateSelectionSteps = function (callback) {
        const self = this;
        var selectedTicket = self.plugin.getCurrentValue('ticket');
        self.plugin.timeslotData = {};


        GeneralUtility.showLoadingAnimationOfAllDateSelectionCards();
        if (selectedTicket && self.plugin.products[selectedTicket] && self.plugin.products[selectedTicket].product.linkedItems) {
            var promises = [];

            self.plugin.products[selectedTicket].product.linkedItems.forEach(function (timeslotArticle) {
                promises.push(
                    new Promise(
                        function (resolve, reject) {
                            self.requestTimeslots(timeslotArticle, function (timeslots) {
                                if (timeslots) {
                                    self.plugin.timeslotData[timeslotArticle] = {};
                                    timeslots.forEach(function (day) {
                                        self.plugin.timeslotData[timeslotArticle][day.date] = day.timeslots;
                                    });
                                    resolve();
                                }
                            });
                        }
                    )
                );

            });


            Promise.all(promises).then(function () {

                let timeslotArticle;
                let i;
                let startIndex = 2;

                //Remove all cloned date selections
                var clonedElements = self.plugin.accordion.querySelectorAll('.card[data-cloned="1"]');
                if (clonedElements && clonedElements.length > 0) {
                    clonedElements.forEach(function (item) {
                        item.remove();
                    });
                }

                //Add time selection steps if more than one timeslot has to be chosen
                if (self.plugin.products[selectedTicket].product.linkedItems.length > 1) {

                    for (i = startIndex; i <= self.plugin.products[selectedTicket].product.linkedItems.length; i++) {
                        timeslotArticle = self.plugin.products[selectedTicket].product.linkedItems[i];

                        if (!self.plugin.accordion.querySelector('.card[data-timeslot="' + timeslotArticle + '"]')) {

                            // Create a clone of element
                            var clonedElement = self.plugin.accordion.querySelectorAll(':scope > *')[startIndex - 1].cloneNode(true);


                            var stepId = i + 1;

                            var stepClass = startIndex + '-' + stepId;

                            // Change the id attribute of the newly created element:
                            clonedElement.dataset.cloned = "1";
                            //clonedElement.querySelector('.step-content').innerHTML = '';
                            clonedElement.classList.remove('card-data');
                            clonedElement.dataset.timeslot = timeslotArticle;
                            clonedElement.dataset.dirty = "1";
                            clonedElement.querySelector('.card-header').setAttribute('id', 'wizard-heading-' + stepClass);
                            clonedElement.querySelector('.card-header A').setAttribute('href', '#wizard-collapse-' + stepClass);
                            clonedElement.querySelector('.card-header A').setAttribute('aria-controls', 'wizard-collapse-' + stepClass);
                            clonedElement.querySelector('div.collapse').setAttribute('aria-labelledby', 'wizard-heading-' + stepClass);
                            clonedElement.querySelector('div.collapse').setAttribute('id', 'wizard-collapse-' + stepClass);
                            self.plugin.accordion.insertBefore(clonedElement, self.plugin.accordion.querySelectorAll(':scope > *')[i]);

                            GeneralUtility.showLoadingAnimationOfCard(clonedElement);

                            self.plugin.initializeStep(clonedElement, (stepId - 1));
                            self.plugin.initializeCollapseElement(clonedElement.querySelector('[data-toggle="collapse"]'));
                        }
                    }
                } else {

                    //Remove time selection steps if only one timeslot has to be chosen and there were multiple timeslots before
                    if (clonedElements && clonedElements.length > 0) {
                        var endIndex = startIndex + self.plugin.products[selectedTicket].product.linkedItems.length;
                        for (i = startIndex; i < endIndex; i++) {
                            self.plugin.removeStep(i);
                        }
                    }

                }

                //Add id of timeslot article as data attribute of the step. The step can now read it to read needed timeslot data
                startIndex = 1;
                for (i = startIndex; i <= self.plugin.products[selectedTicket].product.linkedItems.length; i++) {
                    timeslotArticle = self.plugin.products[selectedTicket].product.linkedItems[i - 1];
                    if (self.plugin.accordion.querySelectorAll(':scope > *')[i].dataset.timeslot !== timeslotArticle) {
                        self.plugin.accordion.querySelectorAll(':scope > *')[i].dataset.timeslot = timeslotArticle;
                        self.plugin.accordion.querySelectorAll(':scope > *')[i].dataset.dirty = "1";
                    }
                }


                GeneralUtility.hideLoadingAnimationOfCard(self.container);
                GeneralUtility.hideLoadingAnimationOfAllDateSelectionCards();


                //Inform all steps that there might be a change
                self.plugin.dispatchEvent('ticketChanged');
                if (callback && typeof callback === 'function') {
                    callback();
                }

            });
        } else {
            GeneralUtility.hideLoadingAnimationOfCard(self.container);


            //Inform all steps that there might be a change
            self.plugin.dispatchEvent('ticketChanged');
        }
    };

    /**
     * Renders input fields for the variants of the chosen product
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.loadVariants = function (item) {
        const self = this;
        var variants = item.dataset.variants.split('|||');
        var html = '';
        variants.forEach(function (variant) {

            if (variant.length > 0) {
                //[articleNumber]:[label]
                var parts = variant.split('---');
                var max = item.dataset.max;
                if (!max) {
                    max = 30;
                }

                var value = 0;
                var currentVariants = self.plugin.getCurrentValue('variants');

                if (currentVariants && currentVariants[parts[0]]) {
                    value = currentVariants[parts[0]];
                }
                var text = parts[1];
                if (parts[2]) {
                    text = '<span ' +
                        'class="badge badge-info" ' +
                        'data-toggle="tooltip" ' +
                        'data-html="true" ' +
                        'data-placement="top" ' +
                        'title="' + parts[2] + '">' +
                        text +
                        '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32.1 33.2" style="enable-background:new 0 0 32.1 33.2;" xml:space="preserve"><path d="M16.1,10.5c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.3,0-4.3,1.9-4.3,4.3C11.9,8.6,13.8,10.5,16.1,10.5"/><polygon points="22.9,28.3 19.8,28.3 19.8,12.5 9.3,12.5 9.3,14.6 12.4,14.6 12.4,28.3 9.3,28.3 9.3,30.5 22.9,30.5 "/></svg>' +
                        '</span>'
                }
                html += '<div class="variant-wrapper d-flex">';
                html += '<label for="variant-' + parts[0] + '">' + text + '</label>';
                html += '<input class="form-control mr-sm-4" type="number" min="0" max="' + max + '" id="variant-' + parts[0] + '" data-ticketid="' + item.dataset.id + '" data-id="' + parts[0] + '" value="' + value + '"/>';
                html += '</div>';
            }
        });
        this.variantsContainer.querySelector('.variants').innerHTML = html;
        this.addVariantInputEvents();

        this.variantsContainer.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
            new Tooltip(tooltip);
        });

    };

    /**
     * Adds change events to variant input fields to adjust max limits depending on max group size
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.addVariantInputEvents = function () {
        const self = this;
        var variantFields = this.variantsContainer.querySelector('.variants').querySelectorAll('input');
        variantFields.forEach(function (variantField) {

            variantField.addEventListener('change', function (item) {
                var oldPersonsCount = self.plugin.getCurrentValue('persons');
                self.adjustMaxAttributesOfVariantFields();
                self.validateStep();
                var newPersonsCount = self.plugin.getCurrentValue('persons');

                if (oldPersonsCount !== newPersonsCount) {
                    GeneralUtility.showLoadingAnimationOfAllDateSelectionCards();
                    self.plugin.accordion.querySelectorAll('.card[data-timeslot]').forEach(function (item) {
                        item.dataset.dirty = "1";

                        //Validate all timeslot selections to verify that changed group size is still valid
                        var index = self.plugin.getIndexOfCard(item);
                        self.plugin.steps[index].validateStep();
                    });
                    GeneralUtility.hideLoadingAnimationOfAllDateSelectionCards();
                }
            });
        });
        self.adjustMaxAttributesOfVariantFields();
        self.validateStep();

    };

    /**
     * Makes AJAX call to retrieve timeslots for the given article and returns array of timeslot data to populate date pickers, ...
     *
     * @returns {array}
     */
    WizardStepTicketSelectionAction.prototype.requestTimeslots = function (timeslotArticle, callback) {
        var url = GeneralUtility.getAjaxUrl('timeslots');
        url = GeneralUtility.appendUrlParameter(url, 'timeslot', timeslotArticle);

        GeneralUtility.ajaxGetRequest(url, function (data) {
            var timeslotData = [];

            if (data) {
                timeslotData = JSON.parse(data);
            }
            callback(timeslotData);
        });
    };

    /**
     * Does pre submit tasks and calls callback function afterward
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.preSubmit = function (callback) {

        if (callback && typeof callback === 'function') {
            callback();
        }


    };

    /**
     * Enables next button if all fields are filled correctly
     *
     * @returns {boolean}
     */
    WizardStepTicketSelectionAction.prototype.validateStep = function () {
        const self = this;
        var valid = true;

        var selectedTicket = this.container.querySelector('.ticket-btn.active');
        var variantFields = false;
        if (selectedTicket) {
            variantFields = this.variantsContainer.querySelector('.variants').querySelectorAll('input[data-ticketid="' + selectedTicket.dataset.id + '"]');
        }

        if (selectedTicket && variantFields) {

            let maxGroupSize = parseInt(selectedTicket.dataset.max);
            if (!maxGroupSize) {
                maxGroupSize = 30;
            }
            const minGroupSize = 1;

            let totalEntered = 0;
            variantFields.forEach(function (field) {
                let enteredValue = field.value.trim();
                if (isNaN(enteredValue) || enteredValue.length === 0) {
                    enteredValue = 0;
                }
                totalEntered += parseInt(enteredValue);
            });

            if (!this.container.querySelector('.ticket-btn.active')) {
                valid = false;
                self.plugin.showError('ticket', 'Kein Ticket gewählt');
            } else {
                self.plugin.removeError('ticket');
            }

            let hasPersonsError = false;
            if (totalEntered === 0) {
                valid = false;
                hasPersonsError = true;
                self.plugin.showError('persons', 'Keine Personenanzahl gewählt');
            } else if (totalEntered > maxGroupSize) {
                valid = false;
                hasPersonsError = true;
                self.plugin.showError('persons', 'Zu viele Personen');
            } else if (totalEntered < minGroupSize) {
                valid = false;
                hasPersonsError = true;
                self.plugin.showError('persons', 'Zu wenige Personen');
            }
            if (!hasPersonsError) {
                self.plugin.removeError('persons');
            }

        } else {
            self.plugin.showError('ticket', 'Kein Ticket gewählt');
            valid = false;
        }

        if (!valid) {
            this.submitContainer.querySelector('.btn-next').setAttribute('disabled', 'disabled');
        } else {
            this.submitContainer.querySelector('.btn-next').removeAttribute('disabled');
        }

        self.setValidState(valid);
        self.plugin.toggleStateOfSubmitButton();
        return valid;
    };

    /**
     * Adjust max limits depending on max group size and values of other fields
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.adjustMaxAttributesOfVariantFields = function () {
        const selectedTicket = this.container.querySelector('.ticket-btn.active');
        let maxGroupSize = 0;
        let variantFields = [];
        if (selectedTicket) {
            maxGroupSize = parseInt(selectedTicket.dataset.max);
            if (!maxGroupSize) {
                maxGroupSize = 30;
            }
            variantFields = this.variantsContainer.querySelector('.variants').querySelectorAll('input[data-ticketid="' + selectedTicket.dataset.id + '"]');
        }


        let totalEntered = 0;
        let totalEnteredInOtherFields = 0;
        let variantsValues = this.plugin.getCurrentValue('variants', totalEntered);
        if (!variantsValues) {
            variantsValues = {};
        }
        variantFields.forEach(function (currentField) {
            totalEnteredInOtherFields = 0;
            let enteredValue = currentField.value.trim();
            if (isNaN(enteredValue) || enteredValue.length === 0) {
                enteredValue = 0;
            }
            variantFields.forEach(function (variantField) {
                if (currentField.dataset.id !== variantField.dataset.id) {
                    totalEnteredInOtherFields += parseInt(variantField.value);
                }
            });
            totalEntered += parseInt(enteredValue);
            currentField.setAttribute('max', (maxGroupSize - totalEnteredInOtherFields));

            variantsValues[currentField.dataset.id] = parseInt(enteredValue);

        });
        this.plugin.setCurrentValue('variants', variantsValues);
        this.plugin.setCurrentValue('persons', totalEntered);
    };


    /**
     * Sets the active location in filter dropdown
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.setActiveDebitor = function (activeElement) {
        const allItems = this.debitorSelect.querySelectorAll('.dropdown-item');
        allItems.forEach(function (item) {
            item.classList.remove('active');
        });

        if (activeElement) {
            activeElement.classList.add('active');

            this.debitorSelect.dataset.selected = activeElement.dataset.id;
            var html = activeElement.dataset.name;
            if (parseInt(activeElement.dataset.id) > 0) {
                html = '<span class="d-none d-md-inline">' + activeElement.dataset.name + '(' + activeElement.dataset.id + ')<span><span class="d-inline d-md-none">' + activeElement.dataset.id + '</span>';
            }
            this.debitorSelect.querySelector('.dropdown-label').innerHTML = html;
            this.plugin.setCurrentValue('debitor', activeElement.dataset.id);
        }
    };

    /**
     *
     * @param valid
     */
    WizardStepTicketSelectionAction.prototype.setValidState = function (valid) {
        this.isValid = valid;
        this.container.dataset.valid = valid;
    };

    /**
     *
     * @returns {boolean}
     */
    WizardStepTicketSelectionAction.prototype.getValidState = function () {
        return this.isValid;
    };

    /**
     *
     * Indicates if data was entered in the step. Used to modify the card header
     *
     * @returns {boolean}
     */
    WizardStepTicketSelectionAction.prototype.hasData = function () {
        var currentValues = this.plugin.getCurrentValues();
        if (currentValues.ticket || currentValues.persons) {
            return true;
        }
        return false;
    };

    /**
     *
     * Hides entered data and shows the generic headline again
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.hideHasDataHeader = function () {
        this.container.classList.remove('card-data');

    };

    /**
     *
     * Modifies the card header.
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.updateHasDataHeader = function () {
        var currentValues = this.plugin.getCurrentValues();

        var dataContainer = this.container.querySelector('.card-header .reservation-data');
        if (this.hasData()) {
            var template = this.reservationDataTemplate.innerHTML;
            var ticketTitle = '';
            if (this.plugin.products[currentValues.ticket]) {
                ticketTitle = this.plugin.products[currentValues.ticket].product.title;
            }

            template = template.replace(/---field:persons---/g, currentValues.persons);
            template = template.replace(/---field:ticket---/g, ticketTitle);
            dataContainer.innerHTML = template;
            dataContainer.querySelector('[data-field-value="ticket"]').innerHTML = ticketTitle;
            dataContainer.querySelector('[data-field-value="persons"]').innerHTML = currentValues.persons;

        }
    };

    /**
     *
     * Shows entered data instead of the generic headline
     *
     * @returns {void}
     */
    WizardStepTicketSelectionAction.prototype.showHasDataHeader = function () {
        if (this.hasData()) {
            this.container.classList.add('card-data');
        } else {
            this.container.classList.remove('card-data');
        }

    };

    return WizardStepTicketSelectionAction;
})();
